import React, { useEffect, useState } from 'react'
import { authAxiosWithBearer, baseURL } from '../../../../baseURL';
import ShowToast from '../../../../Components/ShowToast';
import { useNavigate } from 'react-router-dom';

const InHouseTechnicianSrIssueFormHandle = ({id}) => {
    const navigate = useNavigate()
    const [requisionItemOptions, setRequisionItemOptions] = useState([]);
    const [selectedRequisionItem, setSelectedRequisionItem] = useState([]);
    const [requisionIssueRequiredMessage,setRequisionIssueRequiredMessage]=useState('')
    const [requisionStockOptions, setRequisionStockOptions] = useState([]);
    const [selectedRequisionStock, setSelectedRequisionStock] = useState([]);
    const [isLoading,setIsLoading]=useState(false)

    const [requisionIssueFormData, setRequisionIssueFormData] = useState({
        in_house_technician_sr: null,
        srissueditem_set: [
          {
            in_house_technician_sr_item:null,
            item: null,
            item_id: null,
            uom:'',
            issue_qty:'',
            max_issue_qty:'',
            remarks:'',
            stock_available_qty:'',
          },
        ],
    });


    useEffect(()=>{
    const fetchSingleReqData = async () =>{
        try {
            const response = await authAxiosWithBearer.get(`${baseURL}/in_house/api/in-house-technician-sr-details/${id}/`)
            const responseData = response.data.goods_check_data?.goodscheckedtechnicianfeedback_set[0]?.gctfeedbackpartsdetails_set
            console.log('responseData...',responseData)
            
            const options = responseData
            ?.filter((data)=>data?.available_sr_issue_qty > 0)
            ?.map((data) => ({
                value: data.id,
                label : `${data.item_name} | ${data.item_specification} | ${data.item_size} | ${data.item_brand} | ${data.item_model}`,
                uom: data.uom_text,
                item: data.item,
                quantity:data.quantity,
                max_issue_qty:data.available_sr_issue_qty,
                stock_available_qty:data.item_stock_available_qty
            }));

            console.log('options',options)
            setRequisionItemOptions(options);

            
        } catch (error) {
            console.log(error)
        }
    };fetchSingleReqData();
    },[id])



    const handleRequisionItemChange = (selectedOption, index) => {
        const updatedFormData = { ...requisionIssueFormData };
        
        // Reset issue_qty and stock when the item selection changes
        updatedFormData.srissueditem_set[index] = {
            in_house_technician_sr_item: selectedOption?.value || null,
            item_id: selectedOption?.item || null,
            issue_qty: selectedOption?.max_issue_qty || '',
            item: selectedOption.item,
            uom: selectedOption?.uom || '',
            max_issue_qty: selectedOption?.max_issue_qty || '',
            stock_available_qty: selectedOption?.stock_available_qty || '',
        };
        
        const updatedSelectedRequisionItem = [...selectedRequisionItem];
        updatedSelectedRequisionItem[index] = selectedOption || null;
        
        // Reset selectedRequisionStock for the corresponding index
        const updatedSelectedRequisionStock = [...selectedRequisionStock];
        updatedSelectedRequisionStock[index] = null;
        
        setSelectedRequisionItem(updatedSelectedRequisionItem);
        setSelectedRequisionStock(updatedSelectedRequisionStock);
        setRequisionIssueFormData(updatedFormData);
    };
        

    const handleRequisionIssueInputChange = (e, index, type) => {
        const updatedData = { ...requisionIssueFormData };
        const { name } = e.target;
        let value = e.target.value;  
      
        if (type === 'srissueditem_set' && name === 'issue_qty') {
          const parts = value.split('.');
          const integerPart = parts[0];
          const decimalPart = parts[1] || '';
      
          if (integerPart.length > 12) {
            ShowToast('error', `Ensure that there are no more than 12 digits`);
            return;
          }
      
          if (parts.length === 2) {
            value = `${integerPart}.${decimalPart.slice(0, 2)}`;
      
            if (decimalPart.length > 2) {
              ShowToast('error', `More than 2 digits after the decimal point for ${name}.`);
            }
          }
        }
      
        if (type === 'srissueditem_set') {
          setRequisionIssueRequiredMessage('');
          updatedData.srissueditem_set[index][name] = value;
        } else {
          updatedData[name] = value;
        }
      
        setRequisionIssueFormData(updatedData);
      };
      
    
    const areAllFieldsFilled = () => {
        return (
            requisionIssueFormData.srissueditem_set &&
            requisionIssueFormData.srissueditem_set.every((item) => {
                return item?.in_house_technician_sr_item !== null && item?.issue_qty !== '';
            })
        );
    };
    
      
    const handleAddRequisionIssueItem = () => {
        if (areAllFieldsFilled()) {
            setRequisionIssueFormData((prevState) => ({
                ...prevState,
                srissueditem_set: [
                    ...prevState.srissueditem_set,
                    {
                        in_house_technician_sr_item: null,
                        issue_qty:'',
                    },
                ],
            }));
            setRequisionIssueRequiredMessage('');
        } else {
            setRequisionIssueRequiredMessage("Please fill all fields in the existing field before adding a new one.");
        }
    };
    

    const handleRemoveRequisionIssueItem = (index) => {
      // Create a copy of the damagepartsitem_set array
      const srissueditem_set = [...requisionIssueFormData.srissueditem_set];
    
      const lastIndex = srissueditem_set.length - 1;
  
      const lastItemIsNull = srissueditem_set[lastIndex] && srissueditem_set[lastIndex].in_house_technician_sr_item === null;
      
  
      if (index === lastIndex) {
        srissueditem_set.splice(lastIndex, 1);
      } 
      else if (index !== lastIndex && lastItemIsNull) {
        ShowToast('error','Cannot delete this item because last item is null.');
        return;
      }
      else if (index !== lastIndex && lastItemIsNull === false) {
        srissueditem_set.splice(index, 1);
      }
    
      const updatedSelectedItem = selectedRequisionItem.filter((_, i) => i !== index);
    
      setRequisionIssueRequiredMessage('');
    
      setRequisionIssueFormData({
        ...requisionIssueFormData,
        srissueditem_set,
      });
      setSelectedRequisionItem(updatedSelectedItem);
    };


    

    const handleRequisionIssueSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        try {
          const updatedFormData = { 
            ...requisionIssueFormData,
            in_house_technician_sr: id,
          };
      
          const response = await authAxiosWithBearer.post(`${baseURL}/inventory/api/sr-issued/`, updatedFormData);
      
          if (response) {
            console.log(response);
            ShowToast('success', 'Successfully Submit');
            navigate('/in-house-sr-list');
          }
        } catch (error) {
          console.log(error);
          if(error.response.data.error){
            ShowToast('error', `${error.response.data.error}`);
          }else{
            ShowToast('error', 'Something is wrong');
          }
        }
        finally{
          setIsLoading(false)
        }
    };


  return {
    requisionIssueFormData,
    requisionItemOptions,
    selectedRequisionItem,
    selectedRequisionStock,
    requisionStockOptions,
    requisionIssueRequiredMessage,
    handleRequisionItemChange,
    handleRequisionIssueInputChange,
    handleAddRequisionIssueItem,
    handleRemoveRequisionIssueItem,
    handleRequisionIssueSubmit,
    isLoading,
  }
}

export default InHouseTechnicianSrIssueFormHandle